<template>
  <label
    :for="htmlFor"
    :class="{
      'f-weight-bold': bold,
      'f-size-xx-small': xxsmall,
      'f-size-x-small': xsmall,
      'f-size-small': small,
      'f-size-medium': medium,
      'f-size-large': large,
      'f-family-ja-contract': jaContract,
      'f-family-en-contract': enContract,
      wrapping: wrapping
    }"
    :style="{
      color: color
    }"
    @click="$emit('click', $event)"
    @contextmenu="$emit('contextmenu', $event)"
  >
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'Label',
  props: {
    htmlFor: {
      type: String,
      required: false
    },
    xxsmall: {
      type: Boolean,
      required: false,
      default: false
    },
    xsmall: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    medium: {
      type: Boolean,
      required: false,
      default: false
    },
    large: {
      type: Boolean,
      required: false,
      default: false
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: ''
    },
    jaContract: {
      type: Boolean,
      required: false,
      default: false
    },
    enContract: {
      type: Boolean,
      required: false,
      default: false
    },
    wrapping: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped>
.wrapping {
  padding: 0px 4px 0px 0px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/labels/Label.vue